import { render, staticRenderFns } from "./index.vue.js?vue&type=template&id=48effa35&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=48effa35&scoped=true"
import script from "./index.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue.js?vue&type=script&setup=true&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&setup=true&lang=js"
import style0 from "./index.vue.css?vue&type=style&index=0&id=48effa35&prod&scoped=true&lang=css!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=style&index=0&id=48effa35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48effa35",
  null
  
)

export default component.exports